import { useOutletContext } from 'react-router-dom';
import { useEffectOnce } from 'react-use';

import { websocketActions } from 'app/middleware/websocket/actions/websocket';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { TvDashboardViewOutletContext } from '../../tvDashboard.view';
import { useTvDashboardReloadEffect } from '../../utils/useTvDashboardReloadEffect';

import { TvOrganizationDashboardMetrics } from './components/metrics/tvOrganizationDashboardMetrics';

export const TvOrganizationDashboardView = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { setTitle } = useOutletContext<TvDashboardViewOutletContext>();

  useEffectOnce(() => {
    setTitle('All queues');

    dispatch(
      websocketActions.request({
        type: 'connection:subscribe',
        params: {
          type: 'real_time_dashboard',
          dashboard_type: 'organization',
        },
      }),
    );

    return () => {
      dispatch(
        websocketActions.request({
          type: 'connection:unsubscribe',
          params: {
            type: 'real_time_dashboard',
            dashboard_type: 'organization',
          },
        }),
      );
    };
  });

  useTvDashboardReloadEffect('organization');

  return <TvOrganizationDashboardMetrics />;
};
